import React, {memo} from 'react';
import styled from 'styled-components';

import {extractInitials} from '../../../../libs/shared/core/src/helpers/utilities/stringHelpers';
import {VisitorTeammateAvatar} from '../../../../libs/shared/ui/src/components/avatar/visitorTeammateAvatar';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';

/*
 * Props.
 */

interface DropdownItemVisitorAvatarProps {
  email: string;
}

/*
 * Style.
 */

const StyledAvatarDiv = styled.div`
  grid-area: left-icon;
  margin-right: 8px;
`;

/*
 * Component.
 */

export const DropdownItemVisitorAvatar = memo<DropdownItemVisitorAvatarProps>(({email}) => {
  const initials = extractInitials(email);
  return (
    <StyledAvatarDiv>
      <VisitorTeammateAvatar size={VisualSizesEnum.MEDIUM} initials={initials} />
    </StyledAvatarDiv>
  );
});
